import React from 'react';

import closeNot from '../../assets/images/close_not.svg';
import warning from '../../assets/images/warning.svg';

import './styles.css';

const Notification = ({
  id,
  component,
  expanded,
  message,
  onDismissClick,
  onNotificationPin,
}) => {
  let expandButton;
  if (!component) {
    expandButton = (
      <input
        id={`expandButton${id}`}
        type="button"
        alt="Mobile Navigator"
        styleName={expanded ? 'expandLinkExp' : 'expandLink'}
        onClick={() => {
          onNotificationPin();
        }}
        value={expanded || message.length <= 100 ? message : `${message.substring(0, 100)}...`}
      />
    );
  }

  return (
    <div id={`notifItem${id}`} styleName={expanded ? 'notifItemExpanded' : 'notifItem'}>
      <img styleName="warnImg" src={warning} alt="Notification" />
      <div styleName="message">
        {expandButton || component}
      </div>
      <input
        id={`btnCloseNotif${id}`}
        type="image"
        onClick={onDismissClick}
        src={closeNot}
        alt="Close Notification"
      />
    </div>
  );
};


export default Notification;



// WEBPACK FOOTER //
// ./src/components/Notifications/Notification.js